export default __webpack_public_path__ + "f25d17d77b7704ddc84fbcba113ef715.jpg";